import { Typography } from '@mui/material';
import React from 'react';

const OtpTimer = ({
  minutes = 0,
  seconds = 10,
  over,
  handleOver = () => {},
}: any) => {
  const [time, setTime] = React.useState<any>({
    minutes,
    seconds,
  });

  const tick = () => {
    if (over) return;
    if (time.minutes === 0 && time.seconds === 0) handleOver();
    else if (time.seconds === 0)
      setTime({
        minutes: time.minutes - 1,
        seconds: 59,
      });
    else
      setTime({
        minutes: time.minutes,
        seconds: time.seconds - 1,
      });
  };

  React.useEffect(() => {
    const timerID = setInterval(() => tick(), 1000);
    return () => clearInterval(timerID);
  });

  return (
    <div>
      <Typography
        variant="body2"
        textAlign="right"
        color="primary"
        className="mt-2"
        sx={{ textAlign: 'center' }}
      >{`${time.minutes.toString().padStart(2, '0')}:${time.seconds
        .toString()
        .padStart(2, '0')}`}</Typography>
    </div>
  );
};

export default OtpTimer;
